const PIN_LENGTH = 4;

// formatPin turns a numeric 4-digit PIN back into its display string, restoring leading zeros
// that were lost when the backend serialised the PIN as a number. undefined stays undefined
// so the caller can show a "not set" state.
export function formatPin(pin: number | undefined): string | undefined {
  if (pin === undefined) return undefined;
  return String(pin).padStart(PIN_LENGTH, '0');
}
